import React, { useState } from 'react';

const FinanceForm = ({ type, onAddItem }) => {
  const [formData, setFormData] = useState({
    description: '',
    value: '',
    date: new Date().toISOString().split('T')[0],
    category: type === 'income' ? 'vendas' : 'operacional',
    notes: ''
  });
  
  // Lidar com mudanças nos campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  // Enviar formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!formData.description || !formData.value) {
      alert(`Por favor, preencha a descrição e o valor ${type === 'income' ? 'da receita' : 'da despesa'}!`);
      return;
    }
    
    // Formatar os dados para garantir que os valores sejam numéricos
    const formattedData = {
      ...formData,
      value: parseFloat(formData.value) || 0
    };
    
    // Adicionar item
    onAddItem(formattedData);
    
    // Limpar formulário, mantendo a data e categoria
    setFormData(prev => ({
      ...prev,
      description: '',
      value: '',
      notes: ''
    }));
  };
  
  // Opções de categoria com base no tipo
  const categoryOptions = type === 'income' 
    ? [
        { value: 'vendas', label: 'Vendas' },
        { value: 'servicos', label: 'Serviços' },
        { value: 'assinaturas', label: 'Assinaturas' },
        { value: 'investimentos', label: 'Investimentos' },
        { value: 'outros', label: 'Outros' }
      ]
    : [
        { value: 'operacional', label: 'Operacional' },
        { value: 'marketing', label: 'Marketing' },
        { value: 'infraestrutura', label: 'Infraestrutura' },
        { value: 'impostos', label: 'Impostos' },
        { value: 'pessoal', label: 'Pessoal' },
        { value: 'outros', label: 'Outros' }
      ];
  
  return (
    <form className="finance-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="description">Descrição</label>
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder={`Descreva ${type === 'income' ? 'a receita' : 'a despesa'}`}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="value">Valor (R$)</label>
          <input
            type="number"
            id="value"
            name="value"
            value={formData.value}
            onChange={handleChange}
            placeholder="0.00"
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="date">Data</label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="category">Categoria</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            {categoryOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group full-width">
          <label htmlFor="notes">Observações</label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Observações adicionais (opcional)"
            rows="3"
          ></textarea>
        </div>
      </div>
      
      <div className="form-actions">
        <button type="submit" className={`btn-primary ${type === 'income' ? 'income-btn' : 'expense-btn'}`}>
          {type === 'income' ? 'Adicionar Receita' : 'Adicionar Despesa'}
        </button>
      </div>
    </form>
  );
};

export default FinanceForm;